function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @class issueReducer.
 *
 */
import changeReducerFactory from './factories/changeReducerFactory';
import contentChangeReducerFactory from './factories/contentChangeReducerFactory';
import detailReducerFactory from './factories/detailReducerFactory';
import entityReducerFactory from './factories/entityReducerFactory';
import issueConstants from '../constants/issueConstants';
import uploadReducerFactory from './factories/uploadReducerFactory';
import applyReducer, { reduceReducers } from './applyReducer';
import annotationSelectionConstants from '../constants/annotationSelectionConstants';
const changeReducer = changeReducerFactory('issue');
const contentChangeReducer = contentChangeReducerFactory('issue');
const detailReducer = detailReducerFactory('issue');
const entityReducer = entityReducerFactory('issue');
const uploadReducer = uploadReducerFactory('issue');
const initState = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, changeReducer.initState), detailReducer.initState), entityReducer.initState), uploadReducer.initState), contentChangeReducer.initState), {}, {
  indexQuery: _objectSpread(_objectSpread({}, entityReducer.initState.indexQuery), {}, {
    sortDirection: 'DESC'
  }),
  permissions: {
    view: {
      include: ['issue_show']
    },
    edit: {
      include: ['issue_admin']
    }
  }
});

/**
 * ISSUE_INDEX_BY_REPORT
 */
const indexByReport = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  indexQuery: _objectSpread(_objectSpread({}, action.indexQuery), {}, {
    filters: _objectSpread(_objectSpread({}, action.indexQuery.filters), {}, {
      report: [{
        id: action.reportID,
        name: action.reportName
      }]
    }),
    sortAttribute: 'issueSeverity',
    initialized: false // to force the issues index to re-query
  })
});
const parseContentOnIndexSuccess = state => _objectSpread(_objectSpread({}, state), {}, {
  list: state.list.map(issue => _objectSpread(_objectSpread({}, issue), {}, {
    content: JSON.parse(issue.content)
  }))
});
const clearSelection = (state, action) => {
  if (action.annotationContext === 'issue') {
    return _objectSpread(_objectSpread({}, state), {}, {
      active: {}
    });
  }
  return state;
};
const reducers = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, detailReducer.reducers), entityReducer.reducers), changeReducer.reducers), contentChangeReducer.reducers), uploadReducer.reducers), {}, {
  [issueConstants.INDEX_BY_REPORT]: indexByReport,
  [issueConstants.INDEX_SUCCESS]: reduceReducers(entityReducer.reducers[issueConstants.INDEX_SUCCESS], parseContentOnIndexSuccess),
  [annotationSelectionConstants.CLEAR_SELECTION]: clearSelection
});
export default applyReducer(reducers, initState);